import classNames from "classnames";
import { twMerge } from "tailwind-merge";

type CxArg =
  | string
  | number
  | bigint
  | boolean
  | null
  | undefined
  | Record<string, unknown>
  | CxArg[];

export const cx = (...args: CxArg[]) =>
  // classnames accepts these values at runtime; bigint/symbol falsies are dropped
  twMerge(classNames(args as unknown as classNames.ArgumentArray));
